import { injectTranslate } from '@recruitee/i18n';
import { cellTransformFullDate, textCellFactory } from '@recruitee/user-interface';

import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';
import { defineOfferTableColumn } from './utils';

export const closedAtColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.ClosedAt,
  label: injectTranslate()('app.offers.table.close_date'),
  visible: false,
  geometry: {
    width: 130,
    minWidth: 130,
    maxWidth: 190,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: textCellFactory('closedAt', cellTransformFullDate),
}));
